import React from "react";
import { compose } from "redux";
import { withRouter } from "react-router";
import styled from "styled-components";
import {
  ButtonText,
  PrimaryButton,
  SecondaryButton,
  ButtonSizeOptions
} from "@loanbossinc/component-library";

import { WIDTH } from "../lenderReportingSettings";

const CommonStyle = `
    display: flex;
    flex-direction: row;
`;

const StyledHeaderSectionContainer = styled.div`
    border-top: 1px solid #DADCE0;
    border-bottom: 1px solid #DADCE0;
    padding: 3em 0 10em 0;
    width: 100vw;
    display: flex;
    flex-direction: column;
    gap: 2em;
    align-items: center;
    justify-content: center;
`;

const TitleSection = styled.div`
    width: ${WIDTH};
    display: flex;
    flex-direction: column;
    gap: 1em;
`;

const Title = styled.div`
    font-family: Work Sans;
    font-size: 24px;
    font-weight: 500;
    line-height: 28px;
`;

const SettingsSectionContainer = styled.div`
    ${CommonStyle}
    justify-content: space-between;
    flex-wrap: wrap;
`;

const AllReportsWrapper = styled.div`
    ${CommonStyle}
    width: 50%;
    justify-content: flex-start;
`;

const StyledButtonText = styled(ButtonText)`&&& {
    width: 140px;
    display: flex;
    flex-direction: row;
    place-content: space-around;
}`;

const ResetSaveChangesWrapper = styled.div`
    ${CommonStyle}
    width: 50%;
    justify-content: flex-end;
    gap: 1em;
`;

const StyledPrimaryButton = styled(PrimaryButton)`&&& {
    font-family: Work Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    width: 132px;
}`;

const StyledSecondaryButton = styled(SecondaryButton)`&&& {
    font-family: Work Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    width: 132px;
}`;

const SettingsPageHeader = ({ history, originalPermissionedUsers, setOriginalPermissionedUsers, permissionedUsersState, setPermissionedUsersState, updatePermissionedUsers, deletedUserIds }) => (
  <StyledHeaderSectionContainer>
    <TitleSection>
      <Title>Lender Compliance Settings</Title>
      <SettingsSectionContainer>
        <AllReportsWrapper>
          <StyledButtonText label="All Reports" iconName="arrow_forwards" reverse onClick={() => history.goBack()} />
        </AllReportsWrapper>
        <ResetSaveChangesWrapper>
          <StyledSecondaryButton
            label="Reset"
            size={ButtonSizeOptions.smFluid}
            onClick={() => setPermissionedUsersState(originalPermissionedUsers)}
          />
          <StyledPrimaryButton
            label="Save Changes"
            size={ButtonSizeOptions.smFluid}
            onClick={() => {
              setOriginalPermissionedUsers(permissionedUsersState);
              updatePermissionedUsers({ permissionedUsers: permissionedUsersState, deletedUserIds });
            }}
          />
        </ResetSaveChangesWrapper>
      </SettingsSectionContainer>
    </TitleSection>
  </StyledHeaderSectionContainer>
);

export default compose(withRouter)(SettingsPageHeader);
